import React, { useState, useEffect } from "react";
import style from "../../DetailContainer.module.scss";
import {
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { MyModal } from "../../../Common/Model/MyModal";
import ModalContainer from "../../../Common/Model/ModalContainer";
import SuccessTick from "../../../success_tick";
import { GrDocumentNotes } from "react-icons/gr";
import {
  createCandidateNotes,
  getCandidateNotes,
} from "../../../../services/candidateServices";
import { CgNotes } from "react-icons/cg";
import { decryptedAdminID, formatFullDateTime } from "../../../../utility";
import { AiOutlineClose } from "react-icons/ai";
import Loader from "../../../Common/Loader/Loader";

function Notes({ id }) {
  const [formData, setFormData] = useState({
    eventType: "",
    notes: "",
  });

  const [notesList, setNotesList] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const requiredNotesEvents = [
    "CSS Intro Call",
    "Follow Up Call",
    "Not Qualified",
  ];

  const fetchNotes = async () => {
    try {
      setLoading(true);
      const res = await getCandidateNotes({ can_id: id });
      setNotesList(res.data.data || []);
    } catch (err) {
      console.error("Fetch Notes Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔥 DEBOUNCE EFFECT
  useEffect(() => {
    if (!id) return;

    const timer = setTimeout(() => {
      fetchNotes();
    }, 500); // ⏱️ debounce 500ms

    return () => clearTimeout(timer);
  }, [id]);

  // 🔥 HANDLE CHANGE
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
const adminID = decryptedAdminID();
  // 🔥 CREATE NOTE
  const handleSubmit = async (e) => {
    e.preventDefault();

    const isNotesRequired = requiredNotesEvents.includes(formData.eventType);

    if (isNotesRequired && !formData.notes.trim()) {
      alert("Notes is required for this event type");
      return;
    }

    try {
      await createCandidateNotes({
        can_id: id,
        event_name: formData.eventType,
        notes: formData.notes,
        admin_id: adminID,
        is_notes: true,
      });

      setOpenSuccess(true);
      setOpenForm(false);

      fetchNotes();

      setFormData({ eventType: "", notes: "" });

      setTimeout(() => setOpenSuccess(false), 2000);
    } catch (error) {
      console.error("Create Notes Error:", error);
    }
  };
function handleClose(){
  setOpenForm(false)
  setFormData({eventType:"",notes:""})
}
  return (
    <>
      <div className={style.interviewContainer}>
        <div className={style.title}>Notes</div>

        <div className={style.notesContainer}>
          <div className="d-flex justify-content-end">
            <button
              className={style.primaryButton}
              onClick={() => setOpenForm(true)}
            >
              <GrDocumentNotes /> Create Note
            </button>
          </div>
          <br />
          {/* 🔥 NOTES LIST */}
          <div className={style.notesDataContainer}>
            {loading ? (
              <Loader open={loading} fullScreen={false} />
            ) : notesList.length === 0 ? (
              <div className="d-flex align-items-center justify-content-center">
                <p className="text-danger"><b>No Notes Available</b></p>
              </div>
            ) : (
              notesList.map((item) => (
                <div key={item.id} className={style.notesData}>
                  {/* HTML render */}
                  {/* <div
                    dangerouslySetInnerHTML={{
                      __html: item.event_description,
                    }}
                  /> */}
                  <div className={style.notesHeading}>
                    {" "}
                    <CgNotes />{" "}
                    <strong>Candidate Related - {item.event_name}</strong>{" "}
                  </div>

                  <div className={style.notesdescription}>{item.notes}</div>

                  <div className={style.time}>
                    {formatFullDateTime(item.created_time)}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* 🔥 CREATE FORM MODAL */}
      {openForm && (
        <MyModal>
          <ModalContainer>
            <form onSubmit={handleSubmit}>
              <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                  <h6>Notes Create</h6>
                </div>
                <div>
                  <button className={style.cancelButton}>
                    <AiOutlineClose onClick={handleClose} />
                  </button>
                </div>
              </div>
              <FormControl fullWidth className="mb-3">
                <InputLabel>Event Type</InputLabel>
                <Select
                  value={formData.eventType}
                  label="Event Type"
                  onChange={(e) => handleChange("eventType", e.target.value)}
                  required
                >
                  <MenuItem value="CSS Intro Call">CSS Intro Call</MenuItem>
                  <MenuItem value="Follow Up Call">Follow Up Call</MenuItem>
                  <MenuItem value="Not Qualified">Not Qualified</MenuItem>
                  <MenuItem value="Not Attended">Not Attended</MenuItem>
                  <MenuItem value="Wrong Person">Wrong Person</MenuItem>
                  <MenuItem value="Number Blocked">Number Blocked</MenuItem>
                  <MenuItem value="Not Reachable">Not Reachable</MenuItem>
                  <MenuItem value="Switch Off">Switch Off</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label="Notes"
                multiline
                rows={3}
                fullWidth
                value={formData.notes}
                onChange={(e) => handleChange("notes", e.target.value)}
                inputProps={{ maxLength: 550 }}
                required={[
                  "CSS Intro Call",
                  "Follow Up Call",
                  "Not Qualified",
                ].includes(formData.eventType)}
              />

              <div className="mt-3 d-flex justify-content-end">
                <button type="submit" className={style.primaryButton}>
                  Save
                </button>
              </div>
            </form>
          </ModalContainer>
        </MyModal>
      )}

      {/* ✅ SUCCESS MODAL */}
      {openSuccess && (
        <MyModal>
          <ModalContainer>
            <SuccessTick HeadText={"Successfully Notes Created"} />
          </ModalContainer>
        </MyModal>
      )}
    </>
  );
}

export default Notes;
